@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  font-family: v.$primary-font;
  @include t.text(10px, 12px, "bold");
  color: v.$default-text-color;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.input {
  width: 100%;
  padding: 13px 16px;
  height: 48px;
  font-family: v.$primary-font;
  @include t.text(14px, 22px, "normal");
  color: v.$default-text-color;
  background-color: v.$palette-white;
  border: 1px solid v.$palette-dirty-50;
  border-radius: 8px;
  transition:
    color 300ms ease,
    border-color 300ms ease;
  outline: none;
  box-sizing: border-box;

  &.ghost {
    border: 1px solid transparent;

    @media (pointer: fine) {
      &:hover:not(:disabled):not(.hasError):not(:focus-within) {
        color: v.$palette-orange-2;
      }
    }

    &:disabled {
      color: v.$default-text-color;
      background-color: transparent;
      border-color: transparent;
    }
  }

  &::placeholder {
    color: v.$palette-dirty-70;
  }

  @media (pointer: fine) {
    &:hover:not(:disabled):not(.hasError):not(.ghost) {
      border-color: v.$palette-orange-1;
    }
  }

  &:focus:not(:disabled) {
    border-color: v.$palette-orange-1;
    box-shadow: none;
  }

  &:focus-visible {
    outline: none;
  }

  &[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      appearance: none;
    }
  }

  &:disabled {
    background-color: v.$palette-dirty-10;
    border-color: v.$palette-dirty-40;
    color: v.$palette-dirty-70;
    pointer-events: none;
  }

  &.hasError {
    border-color: v.$color-error;

    &:focus:not(:disabled) {
      border-color: v.$color-error;
      box-shadow: none;
    }
  }
}

.errorText {
  font-family: v.$primary-font;
  @include t.text(12px, 20px, "medium");
  color: v.$color-error;
}
